import React from 'react'
import { useOutletContext } from 'react-router'

type LoginState = {
    e164: string | undefined
    loginType: string
    isSending: boolean
}

export function useLoginContext() {
    return useOutletContext<{
        loginState: LoginState
        setLoginState: React.Dispatch<React.SetStateAction<LoginState>>
    }>()
}
